export const environment = {
    production: true,
    APIEndPoint: 'https://infoprezero.s1.2n.pl/api/v1',
    APITokenValue:
        'QB13xCKLQoLuF4MVUHwWiK4yRqJra29iP8ZxTBtw0MmtdBB6jSj5jA2PO4gUhOQS',
};
